import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_AGREEMENT_URL } from "../constants"
import { IErrorResponse } from "../interface"
import { RootState } from "../../store/store"
import { axios } from "../axios"

const updateAgreement = async (value: boolean, token: string | null) => {
  const response = await axios(API_AGREEMENT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      agreement: value,
    },
  })
  return response.data
}

export const useSignAgreement = () => {
  const token = useSelector((state: RootState) => state.auth.token)
  
  return useMutation<any, IErrorResponse, boolean>({
    mutationFn: (req) => updateAgreement(req, token),
  })
}
